// 针对onScan二次封装，额外提供扫码开始和结束两个callback
import onScan from 'onscan.js'

const forbidKeyCode = [ 8, 16, 17, 18, 20, 37, 38, 39, 40, 46, 91, 93, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 229 ]
const forbidKeyContent = [ 'enter', 'alt', 'meta', 'dead', 'control', 'shift', 'unidentified', 'backspace', 'copy', 'home', 'end', 'pagedown', 'pageup' ]
const Scan = Object.assign({}, onScan)
const scanInterval = 20 // 判断为扫码的间隔
const timeLimit = 200 // 判断扫码结束的时长
let isScan = false
let start = 0
let timer = null

const clearTimer = () => {
  clearTimeout(timer)
  timer = null
}

Scan.scan = (dom = window.document, options = {}) => {
  const { unAttach } = options
  if (Scan.isAttachedTo(dom)) { // 防止重复绑定
    Scan.detachFrom(dom)

    if (unAttach) return
  }
  // if (!options || Object.keys(options).length === 0) return

  options.onKeyDetect = () => {
    const scanDuration = +new Date() - start
    start = +new Date()
    if (!isScan && scanDuration < scanInterval) {
      if (options.onStart) {
        isScan = true
        options.onStart()
      }
    }
    clearTimer()
    timer = setTimeout(() => {
      if (options.onComplete) {
        isScan = false
        options.onComplete()
      }
    }, timeLimit)
  }

  options.keyCodeMapper = function(oEvent) {
    const { key, which  } = oEvent
    if (forbidKeyContent.includes((key || '').toLowerCase())) {
      return null
    }

    if (forbidKeyCode.includes(which || '')) {
      return null;
    }

    // return onScan.decodeKeyEvent(oEvent);
    return key || null
  }

  options.minLength = 4

  return onScan.attachTo(dom, options)
}

window._ScanInstance = Scan

export default Scan